import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import CompartirCatalogoCard from "@/components/CompartirCatalogoCard";

/**
 * Dialog wrapper para el CompartirCatalogoCard. Se abre desde el sidebar
 * o desde cualquier CTA rápido. Auto-carga el link personal del usuario.
 */
export default function CompartirCatalogoDialog({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl w-[calc(100vw-2rem)] sm:w-auto" data-testid="compartir-catalogo-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Comparte tu catálogo</DialogTitle>
        </DialogHeader>
        <div className="mt-2">
          <CompartirCatalogoCard />
        </div>
      </DialogContent>
    </Dialog>
  );
}
